import { useState, useEffect } from 'react'

function Countdown(props) {
  const { seconds, event, formater, onEnd } = props
  const [count, setCount] = useState(seconds)
  const [isEnd, setIsEnd] = useState(false)

  useEffect(() => {
    const interval = setInterval(() => {
      const newCount = count - 1
      if (newCount >= 0) {
        setCount(newCount)
      } else {
        clearInterval(interval)
        setIsEnd(true)
      }
    }, 1000)
    if (!count && event) event()
    return () => clearInterval(interval)
  }, [count, event])

  const formated = formater ? formater(count) : count

  if (isEnd && onEnd) {
    return <>{onEnd()}</>
  }

  return <div>{formated}</div>
}

export default Countdown
